import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { UpdateMobileComponent } from './update-mobile.component';
import { ButtonModule } from '@shared/components/button/button.module';

@NgModule({
	declarations: [UpdateMobileComponent],
	imports: [SharedModule, ButtonModule],
	exports: [UpdateMobileComponent],
})
export class UpdateMobileModule {}
